export enum FileType {
  Html = 'html',
  TypeScript = 'typescript',
  Scss = 'scss'
}